<template>
  <div class="list__action__item--content">
    <div class="flex-row flex__between">
      <p class="name margin-0">
        {{ action.creatorName }}
      </p>
      <div class="time font-size__small">
        <i class="fal fa-clock"></i>
        {{ action.createTime | convertToLabelFilter }}
      </div>
    </div>
    <div>
      <p
        :class="['action-type flex-row flex__left inline-flex', 'color__blue']"
      >
        <i :class="['font-size__small', 'fal fa-check-circle']"></i>
        <span class="font-size__small no_wrap">
          &nbsp;{{ "Thu hồi văn bản từ" }}
        </span>
      </p>

      <!-- diff: data receiverName or deptName (roleName) -->
      <popover-word2 v-for="(word, $index) in words" :key="$index" :word="word">
        <template v-slot:default="options">
          <el-table
            :data="thuHoiReceivers"
            style="width: 100%"
            stripe
            max-height="400"
            :show-header="false"
            size="mini"
          >
            <el-table-column type="index" width="40"></el-table-column>
            <el-table-column
              label="Đơn vị thu hồi"
              width="400"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="padding-0 margin-0">
                  <span class="font-weight__bold font-size__medium">
                    {{ scope.row.receiverName }}
                  </span>
                </span>
              </template>
            </el-table-column>

            <el-table-column label="''" width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="padding-0 margin-0">
                  <span class="font-weight__bold font-size__medium">
                    {{ scope.row.description || "-" }}
                  </span>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </popover-word2>
      <!--coment-->
      <div
        v-if="action.data.comment"
        class="content__message--text content__message--item"
      >
        <el-input
          type="textarea"
          resize="none"
          ref="inputComment"
          autosize
          v-model.trim="action.data.comment"
          disabled
          class="input-display__comment style-fullWidth input-none__border bg__transparent"
        ></el-input>
      </div>
    </div>
  </div>
</template>

<script>
  import convertToLabelFilter from "../../filters/convertToLabelFilter";
  import PopoverWord2 from "../common/popover-word-2";
  import h from "../../services/h";
  import constants from "../../constants";

  export default {
    name: "history-thuhoi-banhanh",
    components: {PopoverWord2},
    props: ["action"],
    filters: {
      convertToLabelFilter
    },
    data() {
      return {
        words: [],
        departments: [],
        vbOutgoingDoc: null,
        vbIncomingDocs: null, //các văn bản đc ban hành trong nội bộ
        outgoingDocAgencies: null, //các văn bản được thu hồi trên trục,
        thuHoiReceivers: []
      };
    },
    created() {
      this.action && this.initData();
    },
    methods: {
      populateThuHoiReceivers() {
        this.thuHoiReceivers = [];
        this.thuHoiReceivers.push(
          ...h.collect(this.vbIncomingDocs, vbIncomingDoc => {
            return {
              receiverName: vbIncomingDoc.toDeptName,
              description: "Đã thu hồi"
            };
          })
        );
        this.thuHoiReceivers.push(
          ...h.collect(this.outgoingDocAgencies, vbOutgoingDocReceivers => {
            return {
              receiverName: vbOutgoingDocReceivers.objectName,
              description:
                vbOutgoingDocReceivers.objectType ===
                constants.RECEIVER_OBJECT_TYPE.DONVI_TRUCLIENTHONG
                  ? "Đã gửi yêu cầu thu hồi"
                  : "Đã thu hồi"
            };
          })
        );
      },

      initData() {
        let dataJson = this.action.dataJson;
        this.vbOutgoingDoc = dataJson.vbOutgoingDoc;
        this.vbIncomingDocs = dataJson.vbIncomingDocs;
        this.outgoingDocAgencies = dataJson.outgoingDocAgencies;
        this.populateThuHoiReceivers();
        let thuHoiReceivers = this.thuHoiReceivers;
        let thuHoiReceivers1stItem = thuHoiReceivers[0];
        let sentence =
          thuHoiReceivers.length === 1
            ? thuHoiReceivers1stItem.receiverName
            : `${
              thuHoiReceivers1stItem.receiverName
            } và ${thuHoiReceivers.length - 1} đơn vị khác`;
        this.words = sentence.split(" ");
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/history-thuthoi-banhanh.vue